import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const CheckboxList = styled.div`
    align-items: center;
    gap: 8px;
`;

export const SwitcherWrap = styled.div`
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;
